import { WithList } from '@bv/api/crud';

class WorkflowApi extends WithList<WorkflowItem> {
  public constructor(public endpoint = 'flow/workflows') {
    super(endpoint);
  }
}

export const workflowApi = new WorkflowApi();
